import { render } from "./LessonDogsTopic2.vue?vue&type=template&id=0dd9ee86"
import script from "./LessonDogsTopic2.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__